import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from "ag-grid-community";
import { AgentOrderHistoryComponent } from '../../components/agent-order-history/agent-order-history.component';
import { ShoppingCartLandingComponent } from '../../components/shopping-cart-landing/shopping-cart-landing.component';

@Component({
  selector: 'cv-reorder-btn-rendered',
  template: `
  <div class="orders-buttonContainer">
    <button type="button" class="reorderButton" [disabled]="!this.agentOrderHistoryComponent.allowBuyAgain(data.PointStoreProductID, data.Variation)" (click)="buttonClicked(data.PointStoreProductID, data.Variation)"
    >{{this.agentOrderHistoryComponent.getLocalizationString("Reorder", "Reorder")}}</button>
  </div>`
})
export class ReorderBtnRenderedComponent implements ICellRendererAngularComp {

  public cellValue!: string;
  public data!: any;

  constructor(
    public agentOrderHistoryComponent: AgentOrderHistoryComponent,
    private shoppingCartLandingComponent: ShoppingCartLandingComponent
    ) { }

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.data = params.data._PointStoreProductOrderedDTO;
    this.cellValue = this.getValueToDisplay(params);
  }

  // gets called whenever the user gets the cell to refresh
  refresh(params: ICellRendererParams) {
    // set value into cell again
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  buttonClicked(id, variation) {
    this.shoppingCartLandingComponent.addCartProductById(id, variation);
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }

}
